import { AuthenticationResult, EventType, InteractionRequiredAuthError } from "@azure/msal-browser";
import { msalInstance } from "./MsalInstance";

const backendScope = {
    scopes: [
        "api://292ece56-e384-4544-9a45-7970d77e2598/on_behalf_of"
    ]
};

const getBackendTokenSilently = async (): Promise<string> => {
    try {
        const response = await msalInstance.acquireTokenSilent(backendScope);
        return response.accessToken;
    } catch (error) {
        console.warn("[MSAL] Silent API token acquisition failed:", error);

        if (error instanceof InteractionRequiredAuthError) {
            try {
                const response = await msalInstance.acquireTokenPopup(backendScope);
                return response.accessToken;
            } catch (popupError) {
                console.error("[MSAL] Popup token acquisition failed:", popupError);
                await msalInstance.logoutRedirect({
                    postLogoutRedirectUri: "/login",
                });
                throw new Error("Authentication failed; user logged out.");
            }
        }

        throw new Error("Failed to acquire API access token.");
    }
};

const loginHandler = async () => {
    await msalInstance.loginRedirect(backendScope).catch((error) => {
        throw new Error("Failed to login : " + error);
    });
}

const logoutHandler = async () => {
    if (msalInstance.getActiveAccount()) {
        sessionStorage.clear();
        window.location.href = "/login"
    }
};

msalInstance.addEventCallback(async (event) => {
    if (event.eventType !== EventType.ACQUIRE_TOKEN_SUCCESS) return;

    const payload = event.payload as AuthenticationResult;
    const account = payload?.account;

    if (!account) return;

    msalInstance.setActiveAccount(account);
});


export {
    loginHandler,
    logoutHandler,
    getBackendTokenSilently,
}